import React, {Ref, RefObject, useEffect, useRef, useState} from "react"
import Styles from "./pageItem.less"
import Konva from "konva"
import ShowDataList from "../../../../../../../function/hooks/showDataList"
import {connect, useDispatch, useSelector} from "react-redux"
import {jumpToAlignment, jumpToPage} from "../../../../../../../function/base/jumpToPage"
import PreInput from "../../../../../../../function/hooks/preInputValue"
import {Image, Layer, Stage, Rect} from "react-konva"
import {Html} from "react-konva-utils"
import TDAShape, {TDAShapeCanvasData} from "../shape/shape"
import {handlePerChange} from "../../../../../../../function/base/positionMapping"
import {ReducerState} from "../../../../../../../reducer/interface/baseInterface"
import {
    CanvasDataByType,
    ContentItem,
    ImageItemData,
    JumpDescription,
    LocationShape,
    OncePageCanvasData,
    SelectShape,
} from "../../../../../../../reducer/interface/dataInterface"
import {isValidKey} from "../../../../../../upload/tips/uploadTips"
import {isNumber} from "lodash-es"

interface PageItemProps {
    type: string
    imgData: ImageItemData
    index: number
    hasData: boolean
    shapeData: CanvasDataByType
    caluShapeFromPos: any
    hoverItem: ContentItem | null
    scaleScal: number
    jumpDesc: JumpDescription
    onSelectShape: SelectShape | null
    adaptWindow: boolean
    pageItemPosition: any
    pageJump: any
    baseRef: RefObject<HTMLDivElement | null>
}

Konva.pixelRatio = 2.0
const PageItem: React.FunctionComponent<PageItemProps> = ({
    type,
    imgData,
    index,
    hasData,
    shapeData,
    caluShapeFromPos,
    hoverItem,
    scaleScal,
    jumpDesc,
    onSelectShape,
    adaptWindow,
    pageItemPosition,
    pageJump,
    baseRef,
}) => {
    const dispatch = useDispatch()
    const preInput = PreInput()
    const rectRef = useRef<Konva.Rect>(null)
    const pageRef = useRef<HTMLDivElement>(null)
    const stageRef = useRef<Konva.Stage>(null)
    const layerRef = useRef<Konva.Layer>(null)
    const pageNumber = index + 1
    const showDataList = ShowDataList()
    const [imgSelfData, setImgSelfData] = useState<any>({
        width: 0,
        height: 0,
        scale: 1, // 基于最初比例放缩后的基本值，相当于左上角的百分之五十，除非替换数据否则不会被修改
        trueScale: 0.5,
    })
    const [image, setImage] = useState<any>(null)
    const [defaultRectSize, setDefaultRectSize] = useState({x: 0, y: 0, width: 0, height: 0})
    useEffect(() => {
        if (!imgData.imgWidth || !imgData.imgHeight) {
            let img = new window.Image()
            const canvasOutBox = document.getElementById(`${type}CanvasOutBox`)
            img.onload = () => {
                if (canvasOutBox) {
                    const scale = canvasOutBox.offsetWidth / img.width
                    setImage(img)
                    setImgSelfData({
                        width: img.width,
                        height: img.height,
                        scale: scale,
                        trueScale: 0.5,
                    })
                }
            }
            img.src = imgData.imgSrc
        } else {
            setImage("新版数据")
            const canvasOutBox = document.getElementById(`${type}CanvasOutBox`)
            const scale = canvasOutBox && canvasOutBox.offsetWidth / imgData.imgWidth
            setImgSelfData({
                width: imgData.imgWidth,
                height: imgData.imgHeight,
                scale: scale,
                trueScale: 0.5,
            })
        }
    }, [imgData, type])
    useEffect(() => {
        if (imgSelfData.trueScale !== scaleScal) {
            setImgSelfData({
                ...imgSelfData,
                trueScale: scaleScal,
            })
        }
    }, [scaleScal])
    useEffect(() => {
        if (image) {
            preInput.changeValue(50)
            const canvasOutBox = document.getElementById(`${type}CanvasOutBox`)
            const scale = canvasOutBox && canvasOutBox.offsetWidth / imgSelfData.width
            setImgSelfData({
                ...imgSelfData,
                scale: scale,
                trueScale: 0.5,
            })
            dispatch({type: "changeScaleScal", payload: 0.5})
        }
    }, [showDataList, adaptWindow])
    useEffect(() => {
        const jumpDescription = isValidKey(`page${type}`, jumpDesc) && jumpDesc[`page${type}`]
        if (pageNumber === jumpDesc[`page${type}`][0]) {
            const absolutePos = {
                type: type,
                pageNum: jumpDesc[`page${type}`],
                x:
                    jumpDesc[`pos${type}`][0].location[0].leftTop.x *
                    handlePerChange(imgSelfData.scale, imgSelfData.trueScale),
                y:
                    jumpDesc[`pos${type}`][0].location[0].leftTop.y *
                    handlePerChange(imgSelfData.scale, imgSelfData.trueScale),
            }
            newRect(jumpDesc[`pos${type}`], pageNumber)
            jumpToPage(absolutePos)
        } else if (
            !(
                rectRef.current?.x() === 0 &&
                rectRef.current?.y() === 0 &&
                rectRef.current?.width() === 0 &&
                rectRef.current?.height() === 0
            )
        ) {
            rectRef.current?.to({
                x: 0,
                y: 0,
                width: 0,
                height: 0,
            })
        }
    }, [jumpDesc])
    useEffect(() => {
        if (onSelectShape) {
            if (pageNumber === onSelectShape[`page${type}`][0]) {
                newRect(onSelectShape[`pos${type}`], pageNumber)
            } else if (
                !(
                    rectRef.current?.x() === 0 &&
                    rectRef.current?.y() === 0 &&
                    rectRef.current?.width() === 0 &&
                    rectRef.current?.height() === 0
                )
            ) {
                rectRef.current?.to({
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0,
                })
            }
        }
    }, [onSelectShape])
    useEffect(() => {
        if (
            caluShapeFromPos &&
            type === caluShapeFromPos.mapping &&
            caluShapeFromPos[`page${type}`] &&
            caluShapeFromPos[`page${type}`].length !== 0 &&
            caluShapeFromPos[`page${type}`][0] === pageNumber
        ) {
            const shapeFromPos = {
                x:
                    caluShapeFromPos[`pos${type}`][0].location[0].leftTop.x *
                    handlePerChange(imgSelfData.scale, imgSelfData.trueScale),
                y:
                    caluShapeFromPos[`pos${type}`][0].location[0].leftTop.y *
                    handlePerChange(imgSelfData.scale, imgSelfData.trueScale),
                width:
                    (caluShapeFromPos[`pos${type}`][0].location[0].leftBottom.x -
                        caluShapeFromPos[`pos${type}`][0].location[0].leftTop.x) *
                    handlePerChange(imgSelfData.scale, imgSelfData.trueScale),
                height:
                    (caluShapeFromPos[`pos${type}`][0].location[0].leftBottom.y -
                        caluShapeFromPos[`pos${type}`][0].location[0].leftTop.y) *
                    handlePerChange(imgSelfData.scale, imgSelfData.trueScale),
            }
            // console.log({shapeFromPos: shapeFromPos, caluShapeFromPos: caluShapeFromPos[`pos${type}`][0]})
            dispatch({
                type: "saveShapeFromPos",
                payload: {
                    ...caluShapeFromPos,
                    shapeFromPos: shapeFromPos,
                },
            })
        }
    }, [caluShapeFromPos])
    useEffect(() => {
        savePageItemPosition()
    }, [imgSelfData])
    useEffect(() => {
        if (pageJump[type].find) {
            let beFoundData = null
            for (let key in shapeData) {
                beFoundData = shapeData[key].find((item: any) => item.diffIndex === pageJump.diffIndex)
                if (beFoundData) {
                    break
                }
            }
            if (beFoundData) {
                const pagePosition = pageItemPosition[type].filter((item: any) => item.pageNum === pageNumber)[0]
                    .position
                const pageJumpData = {
                    ...pageJump,
                    [type]: {
                        ...pageJump[type],
                        blockPos: beFoundData.locationShape.location[0],
                        mappingPos: {
                            x:
                                beFoundData.locationShape.location[0].leftTop.x *
                                handlePerChange(imgSelfData.scale, imgSelfData.trueScale),
                            y:
                                pagePosition.top +
                                beFoundData.locationShape.location[0].leftTop.y *
                                    handlePerChange(imgSelfData.scale, imgSelfData.trueScale),
                            width:
                                (beFoundData.locationShape.location[0].leftBottom.x -
                                    beFoundData.locationShape.location[0].leftTop.x) *
                                handlePerChange(imgSelfData.scale, imgSelfData.trueScale),
                            height:
                                (beFoundData.locationShape.location[0].leftBottom.y -
                                    beFoundData.locationShape.location[0].leftTop.y) *
                                handlePerChange(imgSelfData.scale, imgSelfData.trueScale),
                        },
                        pageNum: pageNumber,
                        from: type,
                        jump: true,
                        find: false,
                    },
                }
                dispatch({type: "onPageJump", payload: pageJumpData})
            }
        }
    }, [pageJump])
    const savePageItemPosition = () => {
        dispatch({
            type: "savePageItemPosition",
            payload: {
                type: type,
                pageNum: pageNumber,
                hasData: hasData ? hasData : pageNumber === 1,
                position: {
                    top: pageRef.current?.offsetTop,
                    bottom: pageRef.current && pageRef.current.offsetTop + pageRef.current.offsetHeight,
                },
            },
        })
    }
    const getImg = () => {
        let img = new window.Image()
        img.src = imgData.imgSrc
        return img
    }
    // 以Canvas背景形式绘制img，卡顿略大
    // const renderImg = <Image x={0} y={0} width={imgSelfData.width} height={imgSelfData.height} image={getImg()} />
    // 以Div背景形式绘制img，卡顿小速度快。实际效果待测试
    const renderHtml = () => {
        return (
            <Html
                divProps={{
                    style: {
                        position: "absolute",
                        zIndex: -1,
                        transform: `scale(${handlePerChange(imgSelfData.scale, imgSelfData.trueScale)})`,
                    },
                }}
            >
                {<img className={Styles.backgroundImg} src={imgData.imgSrc} />}
            </Html>
        )
    }

    const clickShape = (shapeAllData: TDAShapeCanvasData) => {
        const findType = type === "Base" ? "Compare" : "Base"
        const pagePosition = pageItemPosition[type].filter((item: any) => item.pageNum === pageNumber)[0].position
        const scrollTop = baseRef.current?.scrollTop ? baseRef.current?.scrollTop : 0
        const pageJumpData = {
            [type]: {
                ...pageJump[type],
                blockPos: shapeAllData.data,
                blockVisualPos: {
                    height:
                        pagePosition.top +
                        shapeAllData.data.leftTop.y * handlePerChange(imgSelfData.scale, imgSelfData.trueScale) -
                        scrollTop,
                },
                mappingPos: {
                    x: shapeAllData.data.leftTop.x * handlePerChange(imgSelfData.scale, imgSelfData.trueScale),
                    y:
                        pagePosition.top +
                        shapeAllData.data.leftTop.y * handlePerChange(imgSelfData.scale, imgSelfData.trueScale),
                    width:
                        (shapeAllData.data.leftBottom.x - shapeAllData.data.leftTop.x) *
                        handlePerChange(imgSelfData.scale, imgSelfData.trueScale),
                    height:
                        (shapeAllData.data.leftBottom.y - shapeAllData.data.leftTop.y) *
                        handlePerChange(imgSelfData.scale, imgSelfData.trueScale),
                },
                pageNum: pageNumber,
                from: type,
                jump: false,
                find: false,
                follow: false,
            },
            [findType]: {
                ...pageJump[findType],
                find: true,
                follow: true,
            },
            diffType: shapeAllData.diffType,
            diffIndex: shapeAllData.diffIndex,
            listJump: true,
        }
        dispatch({type: "onPageJump", payload: pageJumpData})
    }

    const putShape = () => {
        let data: Array<TDAShapeCanvasData> = []
        for (let key in shapeData) {
            shapeData[key].forEach((onceData: OncePageCanvasData) => {
                onceData.locationShape.location.forEach((item: any) => {
                    data.push({
                        diffIndex: onceData.diffIndex,
                        diffType: onceData.diffType,
                        data: item,
                        allShapeData: onceData.locationShape,
                    })
                })
            })
        }
        return data.map((onceData, index) => (
            <TDAShape
                dispatch={dispatch}
                handleClickShape={clickShape}
                key={index}
                mapping={type}
                hoverItem={hoverItem}
                data={onceData}
            />
        ))
    }
    const newRect = (data: Array<LocationShape>, pageNum: number | string) => {
        const shapeIndex = data.findIndex((item) => item.pageNum === pageNum)
        if (shapeIndex >= 0) {
            let maxX = data[shapeIndex].location[0].leftTop.x
            let minX = data[shapeIndex].location[0].leftTop.x
            let maxY = data[shapeIndex].location[0].leftTop.y
            let minY = data[shapeIndex].location[0].leftTop.y
            data[shapeIndex].location.forEach((location) => {
                for (let key in location) {
                    maxX = location[key].x > maxX ? location[key].x : maxX
                    minX = location[key].x < minX ? location[key].x : minX
                    maxY = location[key].y > maxY ? location[key].y : maxY
                    minY = location[key].y < minY ? location[key].y : minY
                }
            })
            if (!rectRef.current) {
                setDefaultRectSize({
                    x: minX - 20,
                    y: minY - 20,
                    width: maxX - minX + 40,
                    height: maxY - minY + 40,
                })
            }
            rectRef.current?.to({
                x: minX - 40,
                y: minY - 40,
                width: maxX - minX + 80,
                height: maxY - minY + 80,
                onFinish: () => {
                    rectRef.current?.to({
                        x: minX - 20,
                        y: minY - 20,
                        width: maxX - minX + 40,
                        height: maxY - minY + 40,
                    })
                },
            })
        }
    }
    const renderLayer = () => {
        return (
            <Layer ref={layerRef}>
                {/* {renderImg} */}
                {renderHtml()}
                <Rect ref={rectRef} stroke={"red"} strokeWidth={0.005 * imgSelfData.width} {...defaultRectSize} />
                {putShape()}
            </Layer>
        )
    }
    const renderStage = () => {
        if (hasData) {
            return (
                <Stage
                    ref={stageRef}
                    width={imgSelfData.width * handlePerChange(imgSelfData.scale, imgSelfData.trueScale)}
                    height={imgSelfData.height * handlePerChange(imgSelfData.scale, imgSelfData.trueScale)}
                    scaleX={handlePerChange(imgSelfData.scale, imgSelfData.trueScale)}
                    scaleY={handlePerChange(imgSelfData.scale, imgSelfData.trueScale)}
                    className={Styles.onceCanvasBox}
                >
                    {renderLayer()}
                </Stage>
            )
        } else {
            return null
        }
    }
    return (
        <div
            id={`${type}Page${pageNumber}`}
            style={{
                width: imgSelfData.width * handlePerChange(imgSelfData.scale, imgSelfData.trueScale),
                height: imgSelfData.height * handlePerChange(imgSelfData.scale, imgSelfData.trueScale),
            }}
            ref={pageRef}
            className={Styles.oncePage}
            key={`${type}Page${pageNumber}`}
        >
            {renderStage()}
        </div>
    )
}

export default connect((state: ReducerState) => {
    return {
        pageJump: state.control.pageJump,
        caluShapeFromPos: state.data.caluShapeFromPos,
        hoverItem: state.data.hoverItem,
        lastHoverItem: state.data.lastHoverItem,
        scaleScal: state.data.scaleScal,
        jumpDesc: state.data.jumpDesc,
        onSelectShape: state.data.onSelectShape,
        adaptWindow: state.data.adaptWindow,
        pageItemPosition: state.control.pageItemPosition,
    }
})(PageItem)
